import React from 'react';
import PropTypes from 'prop-types';

// children must be an input
export const InputAddOn = ({ children, leftAddon, rightAddon, height, width }) => {
  const feedbackStyles = {
    position: 'absolute',
    top: 0,
    [leftAddon ? 'left' : 'right']: 0,
    zIndex: 2,
    display: 'block',
    width: width || '38px',
    height: height || '42px',
    lineHeight: height || '42px',
    textAlign: 'center',
    color: 'red'
  };
  const childrenStyle = leftAddon || rightAddon ? {
    [leftAddon ? 'paddingLeft' : 'paddingRight']: '42.5px'
  } : {};
  return (
    <div style={{ position: 'relative' }} className="input-feedback">
      { leftAddon && <div style={feedbackStyles} aria-hidden="true">{leftAddon}</div> }
      {React.cloneElement(children, { style: childrenStyle })}
      { rightAddon && <div style={feedbackStyles} aria-hidden="true">{rightAddon}</div> }
    </div>
  );
};

InputAddOn.propTypes = {
  children: PropTypes.element,
  leftAddon: PropTypes.element,
  rightAddon: PropTypes.element,
  height: PropTypes.string,
  width: PropTypes.string
};
